import { Dialog as UIDialog, DialogActions as UIActions, DialogContent as UIContent } from "@evergis/ui";
import styled from "styled-components";

export const DialogContent = styled(UIContent)`
  width: 100%;
  padding: 0;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  svg {
    margin-bottom: 2rem;
    margin-top: 1.4rem;
    width: 2.5rem;
  }

  span {
    font-size: 1rem;
    font-weight: 600;
  }
`;

export const Dialog = styled(UIDialog)`
  max-width: 22.375rem;
  align-items: center;
  padding: 1.3rem 1.2rem;
`;

export const DialogActions = styled(UIActions)`
  padding-bottom: 1.5rem;

  button {
    font-size: 1rem;
  }
`;
